document.addEventListener('DOMContentLoaded', function() {
  var swiper = new Swiper('.popular-collections__slider', {
    slidesPerView: 'auto',
    spaceBetween: 6,
    navigation: {
      nextEl: '.popular-collections__next-button',
      prevEl: '.popular-collections__prev-button',
    },
    breakpoints: {
      320: { slidesPerView: 2 },
      576: { slidesPerView: 3 },
      769: { slidesPerView: 4 },
      1025: { slidesPerView: 5 }
    }
  });
});
